<template>
  <div class="layout-container">
    <!-- 顶部导航栏 -->
    <header class="header">
      <div class="header-left">
        <span class="logo">管理系统</span>
      </div>
      <div class="header-right">
        <el-dropdown trigger="click" class="user-info">
          <span class="el-dropdown-link">
            <i class="el-icon-user"></i>
            <span>{{ username }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="handleUpdatePassword">修改密码</el-dropdown-item>
            <el-dropdown-item @click.native="handleLogout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </header>
    
    <!-- 主体内容区 -->
    <div class="main-container">
      <!-- 侧边栏 -->
      <aside class="sidebar">
        <el-menu
          :default-active="activeMenu"
          class="el-menu-vertical-demo"
          @select="handleMenuSelect"
          background-color="#ffffff"
          text-color="#606266"
          active-text-color="#38b63c"
        >
          <!-- 动态渲染菜单 -->
          <template v-for="menu in menuList">
            <!-- 无子菜单 -->
            <el-menu-item
              v-if="!menu.children || menu.children.length === 0"
              :key="menu.id"
              :index="menu.path"
            >
              <img v-if="menu.iconImg" :src="menu.iconImg" class="menu-icon" />
              <i v-else-if="menu.icon" :class="menu.icon"></i>
              <span slot="title">{{ menu.name }}</span>
            </el-menu-item>
            
            <!-- 有子菜单 -->
            <!-- <el-submenu
              v-else
              :key="menu.id"
              :index="menu.path"
            >
              <template slot="title">
                <img v-if="menu.iconImg" :src="menu.iconImg" class="menu-icon" />
                <i v-else-if="menu.icon" :class="menu.icon"></i>
                <span>{{ menu.name }}</span>
              </template>
              <el-menu-item
                v-for="subMenu in menu.children"
                :key="subMenu.id"
                :index="`${menu.path}/${subMenu.path}`"
              >
                <span slot="title">{{ subMenu.name }}</span>
              </el-menu-item>
            </el-submenu> -->
          </template>
        </el-menu>
      </aside>
      
      <!-- 内容区 -->
      <main class="content">
        <router-view />
      </main>
    </div>

      <!-- 修改密码弹窗 -->
  <el-dialog
    title="修改密码"
    :visible.sync="updatePasswordDialogVisible"
    width="500px"
    :before-close="handleClosePasswordDialog"
  >
    <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-width="100px">
      <el-form-item label="旧密码" prop="oldPassword">
        <el-input type="password" v-model="passwordForm.oldPassword" placeholder="请输入旧密码" />
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input type="password" v-model="passwordForm.newPassword" placeholder="请输入新密码" />
      </el-form-item>
      <el-form-item label="确认新密码" prop="confirmPassword">
        <el-input type="password" v-model="passwordForm.confirmPassword" placeholder="请再次输入新密码" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClosePasswordDialog">取消</el-button>
      <el-button type="primary" @click="handleSubmitPassword">确定</el-button>
    </span>
  </el-dialog>
  </div>


</template>

<script>
import { updatePassword } from '../api/auth'
import { userApps, appDetails } from '@/config/user_app_config'

export default {
  name: 'Layout',
  data() {
    return {
      username: '',
      activeMenu: 'home',
      menuList: [],
      assetIcons: {},
      renameMap: {
        '财务': '财务管理',
        '公司': '分组管理',
        '区域': '区域管理',
        '系统': '系统设置',
        '应用': '系统应用',
        '员工': '员工管理',
        '用户': '用户管理',
        '设备': '设备管理',
        '清运': '清运管理',
        '投递': '投递管理'
      },
      removedAssetNames: ['会员', '订单', '清运', '设备', '数据', '财务管理', '公司'],
      desiredOrder: [
        '首页',
        '数据看板',
        '用户管理',
        '设备管理',
        '清运管理',
        '投递管理',
        '设备重量记录',
        '分组管理',
        '员工管理',
        '意见反馈',
        '上门回收',
        '便民驿站',
        '分拣中心',
        '财务管理',
        '清运量统计',
        '清运员统计',
        '设备投递量统计',
        '用户提现管理',
        '区域管理',
        '系统应用',
        '系统设置'
      ],
      // 修改密码相关
      updatePasswordDialogVisible: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.passwordForm.newPassword) {
                callback(new Error('两次输入的新密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    // 从store中获取路由权限
    routes() {
      return this.$store.state.permission.routes
    }
  },
  methods: {
    // 获取当前激活的菜单
    getActiveMenu() {
      const path = this.$route.path
      // 保持完整路径，与 el-menu-item 的 index 匹配
      this.activeMenu = path
      
      // 特殊处理：用户列表页高亮用户管理菜单
      if (path === '/users/list') {
        this.activeMenu = '/users'
      }
    },
    
    // 菜单选择处理
    handleMenuSelect(index) {
      console.log('Menu clicked, path:', index);
      // 确保 index 是字符串
      index = String(index);
      
      // 将资产菜单映射到真实路由
      if (index === '/asset-company' || index === 'asset-company') {
        index = '/cleaning-groups'
      }
      // 用户管理入口统一跳转到列表页
      if (index === '/users' || index === 'users') {
        index = '/users/list'
      }
      // 外部数据看板跳转
      if (index === '/dashboard-external' || index === 'dashboard-external') {
        window.open('https://zs.zhiwahuishou.com/', '_blank')
        return
      }
      
      // 处理配置化应用的跳转
      const appName = Object.keys(appDetails).find(key => 
        index === '/' + appDetails[key].path || index === appDetails[key].path
      )
      if (appName) {
        const path = index.startsWith('/') ? index : `/${index}`
        this.$router.push(path)
        return
      }

      const isAsset = index.startsWith('/asset-') || index.startsWith('asset-')
      const allowAssets = new Set(['/asset-cleaning-stats', 'asset-cleaning-stats', '/asset-device-delivery-stats', 'asset-device-delivery-stats'])
      if (isAsset && !allowAssets.has(index)) {
        this.$message.info('此功能暂未开放')
        return
      }
      // 确保路径格式正确，不添加重复的斜杠
      const path = index.startsWith('/') ? index : `/${index}`;
      this.$router.push(path).catch(err => {
        // 忽略重复导航错误
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    },
    
    // 退出登录（带确认）
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleForceLogout()
      }).catch(() => {
        // 用户取消退出
        this.$message.info('已取消退出')
      })
    },
    
    // 强制退出登录（不带确认）
    handleForceLogout() {
      // 清除token和用户信息
      this.$store.dispatch('auth/logout')
      // 清除权限数据
      this.$store.dispatch('permission/clearPermissions')
      // 跳转到登录页
      this.$router.push('/login')
    },
    
    // 打开修改密码弹窗
    handleUpdatePassword() {
      this.updatePasswordDialogVisible = true
    },
    
    // 关闭修改密码弹窗
    handleClosePasswordDialog() {
      // 重置表单
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.resetFields()
      }
      this.updatePasswordDialogVisible = false
    },
    
    // 提交修改密码
    async handleSubmitPassword() {
      this.$refs.passwordForm.validate(async (valid) => {
        if (valid) {
          // 验证新密码与旧密码不能一致
          if (this.passwordForm.oldPassword === this.passwordForm.newPassword) {
            this.$message.error('新密码不能与旧密码相同')
            return
          }
          
          try {
            // 调用更新密码接口
            const response = await updatePassword({
              old_password: this.passwordForm.oldPassword,
              new_password: this.passwordForm.newPassword
            })
            
            if (response.code === "SUCCESS") {
              this.$message.success('密码修改成功')
              // 密码修改成功后强制退出登录，不需要用户确认
              setTimeout(() => {
                this.handleForceLogout()
              }, 1500)
            } else {
              this.$message.error((response.error && response.error.message) || '密码修改失败')
            }
          } catch (error) {
            this.$message.error('修改密码失败')
            console.error('Update password error:', error)
          }
        }
      })
    },
    
    // 获取用户名
    getUsername() {
      this.username = this.$store.state.auth.userInfo.username || localStorage.getItem('username') || '未登录'
    },
    
    // 生成菜单列表
    loadAssetIcons() {
      const ctx = require.context('@/assets/cd', false, /\.png$/)
      const icons = {}
      ctx.keys().forEach(k => {
        const name = k.replace('./', '').replace('.png', '')
        icons[name] = ctx(k)
      })
      this.assetIcons = icons
    },
    normalize(str) {
      return String(str || '').toLowerCase()
    },
    getIconImgForMenu(menu) {
      const name = this.normalize(menu.name)
      // 统一去斜杠比较
      const menuPath = this.normalize(menu.path).replace(/^\//, '')
      const activePath = this.normalize(this.activeMenu).replace(/^\//, '')
      
      const isActive = activePath === menuPath || activePath.startsWith(menuPath + '/')
      
      // 如果已经有指定的 iconBaseName（手动指定的），直接使用
      let iconKey = menu.iconBaseName || ''

      if (!iconKey) {
        const map = {
          shouye: '首页',
          shebeitongji: '数据看板',
          yonghu: '用户管理',
          shebeiguanli: '设备管理',
          qingyunguanli: '清运管理',
          toudiguanli: '投递管理',
          shebeitoudijilu: '设备重量记录',
          fenzuguanli: '分组管理',
          // 'yuangong': '员工管理', // 暂无员工图标，复用用户图标或默认
          yijianfankui: '意见反馈',
          shangmenhuihou: '上门回收',
          bianminyizhan: '便民驿站',
          fenjianzhongxin: '分拣中心',
          // 'caiwu': '财务管理', // 暂无财务图标
          qingyunliangtongji: '清运量统计',
          qingyunyuantongji: '清运员统计',
          shebeitongji2: '设备投递量统计',
          yonghutixian: '用户提现管理',
          // 'quyu': '区域管理', // 暂无区域图标
          xitongyingyong: '系统应用',
          // 'xitong': '系统设置' // 暂无系统图标
        }
        
        // 优先进行精确匹配，解决部分菜单名称包含导致匹配错误的问题
        const exactMap = {
          '首页': 'shouye',
          '数据看板': 'shebeitongji',
          '用户管理': 'yonghu',
          '设备管理': 'shebeiguanli',
          '清运管理': 'qingyunguanli',
          '投递管理': 'toudiguanli',
          '设备重量记录': 'shebeitoudijilu',
          '分组管理': 'fenzuguanli',
          '意见反馈': 'yijianfankui',
          '上门回收': 'shangmenhuihou',
          '便民驿站': 'bianminyizhan',
          '分拣中心': 'fenjianzhongxin',
          '清运量统计': 'qingyunliangtongji',
          '清运员统计': 'qingyunyuantongji',
          '设备投递量统计': 'shebeitongji2',
          '用户提现管理': 'yonghutixian',
          '系统应用': 'xitongyingyong'
        }

        // 查找对应的图标键
        // 1. 尝试精确匹配
        if (exactMap[name]) {
            iconKey = exactMap[name]
        } else {
            // 2. 尝试模糊匹配（旧逻辑）
            for (const [key, val] of Object.entries(map)) {
              if (name === val || name.includes(val)) {
                iconKey = key
                break
              }
            }
        }
        
        if (!iconKey) {
          // 备用匹配逻辑
          if (menuPath.includes('home')) iconKey = 'shouye'
          else if (menuPath.includes('user')) iconKey = 'yonghu'
          else if (menuPath.includes('device')) iconKey = 'shebeiguanli'
          else if (menuPath.includes('cleaning')) iconKey = 'qingyunguanli'
          else if (menuPath.includes('delivery')) iconKey = 'toudiguanli'
          else if (menuPath.includes('feedback')) iconKey = 'yijianfankui'
          else if (menuPath.includes('door')) iconKey = 'shangmenhuihou'
          else if (menuPath.includes('station')) iconKey = 'bianminyizhan'
          else if (menuPath.includes('sorting')) iconKey = 'fenjianzhongxin'
          else if (menuPath.includes('app')) iconKey = 'xitongyingyong'
        }
      }

      if (iconKey) {
        // 特殊处理 shebeitongji2，如果只有 shebeitongji 的图标
        if (iconKey === 'shebeitongji2' && !this.assetIcons['shebeitongji2w']) {
            iconKey = 'shebeitongji'
        }
        
        const suffix = isActive ? 'x' : 'w'
        const fullName = iconKey + suffix
        if (this.assetIcons[fullName]) {
          return this.assetIcons[fullName]
        }
        // 尝试不带后缀的（兼容旧逻辑，如果有的话）
        if (this.assetIcons[iconKey]) {
            return this.assetIcons[iconKey]
        }
      }
      
      return null
    },
    addMissingMenusFromAssets(baseMenus) {
      const existing = new Set(baseMenus.map(m => m.name))
      const labels = {
        home: '首页',
        huiyuan: '会员',
        shebei: '设备',
        dingdan: '订单',
        qingyun: '清运',
        shuju: '数据',
        caiwu: '财务',
        qudao: '渠道',
        xitong: '系统',
        yingyong: '应用',
        yuangong: '员工',
        company: '公司',
        quyu: '区域',
        // 新增对应 assetIcons 的键名
        xitongyingyong: '系统应用',
        bianminyizhan: '便民驿站',
        fenjianzhongxin: '分拣中心',
        fenzuguanli: '分组管理',
        qingyunguanli: '清运管理',
        qingyunliangtongji: '清运量统计',
        qingyunyuantongji: '清运员统计',
        shangmenhuihou: '上门回收',
        shebeiguanli: '设备管理',
        shebeitongji: '数据看板',
        shebeitoudijilu: '设备重量记录',
        toudiguanli: '投递管理',
        yijianfankui: '意见反馈',
        yonghutixian: '用户提现管理',
        yonghu: '用户管理',
        shouye: '首页'
      }
      
      // 提取基础名并去重
      const baseIconNames = new Set()
      Object.keys(this.assetIcons).forEach(key => {
          // 去掉末尾的 w 或 x
          let base = key
          if (key.endsWith('w')) base = key.slice(0, -1)
          else if (key.endsWith('x')) base = key.slice(0, -1)
          baseIconNames.add(base)
      })

      baseIconNames.forEach(key => {
        // 严格过滤：必须在 labels 中定义了中文名才添加，防止出现拼音菜单
        if (!labels[key]) return

        let name = labels[key]
        if (this.renameMap[name]) name = this.renameMap[name]
        if (this.removedAssetNames.includes(labels[key])) return
        if (key === 'shuju2' || name === 'shuju2') return
        if (!existing.has(name) && name !== '渠道管理' && name !== '渠道' && name !== '系统设置' && name !== '财务管理') {
          const isApps = key === 'yingyong'
          baseMenus.push({
            id: isApps ? 'system-apps' : `asset-${key}`,
            path: isApps ? '/system-apps' : `/asset-${key}`,
            name,
            iconBaseName: key
          })
          existing.add(name)
        }
      })
    },
    generateMenuList() {
      // 使用 router.options.routes 中的 Layout 子路由，确保包含静态路由（如分组管理等）
      // 注意：this.routes (Vuex) 可能只包含动态路由，缺少静态定义的路由
      const layoutRoute = this.$router.options.routes.find(r => r.path === '/')
      // 使用 map 创建新对象，避免直接修改路由原始对象
      let rawMenus = (layoutRoute && layoutRoute.children) ? layoutRoute.children.map(item => ({ ...item })) : (Array.isArray(this.routes) ? this.routes.map(item => ({ ...item })) : [])

      // 1. 预处理：规范化 path 和 name
      rawMenus.forEach(m => {
          if (!m.path) m.path = ''
          // 确保路径是绝对路径，以便与 $route.path 匹配
          if (!m.path.startsWith('/') && !m.path.startsWith('http')) {
            m.path = '/' + m.path
          }
          if (m.meta && m.meta.title) m.name = m.meta.title
      })
      
      // 2. 去重：根据 path 和 name 去重
      const uniqueMenus = []
      const seenPaths = new Set()
      const seenNames = new Set()
      
      rawMenus.forEach(m => {
        const path = m.path
        const name = m.name
        
        // 忽略空路径
        if (!path) return
        
        // 如果路径已存在，跳过
        if (seenPaths.has(path)) return
        
        // 如果名字已存在，跳过
        if (seenNames.has(name)) return
        
        seenPaths.add(path)
        seenNames.add(name)
        uniqueMenus.push(m)
      })

      const baseMenus = uniqueMenus
      
      this.addMissingMenusFromAssets(baseMenus)
      baseMenus.forEach(m => { if (this.renameMap[m.name]) m.name = this.renameMap[m.name] })
      const filtered = baseMenus.filter(m => {
        const n = m.name
        const isRemovedAsset = String(m.id).startsWith('asset-') && this.removedAssetNames.includes(n)
        const isLoginIllustration = n === 'login-illustration'
        const isUndesired = ['cxzx', 'hylb', 'mybj', 'qyd', 'qylb', 'sjgk', 'tddd', 'tggl', 'yhtx', 'hygl', 'myjb', 'yggl'].includes(n)
        const isChannel = n === '渠道' || n === '渠道管理'
        const isDashboard = n === '数据看板'
        const isSystemSettings = n === '系统设置'
        const isEmployees = n === '员工管理'
        const isRegion = n === '区域管理' || n === '区域'
        // 过滤掉用户列表（因为已有用户管理）
        const isUsersList = n === '用户列表' || m.path === '/users/list'
        
        // 移除用户指定的菜单
        const isDeliveries = n === '投递订单'
        const isClearance = n === '清运列表'
        
        // 默认隐藏这些应用，由 SystemApps 控制显示
        const isDoorRecycling = n === '上门回收'
        const isServiceStation = n === '便民驿站'
        const isSortingCenter = n === '分拣中心'

        return !isRemovedAsset && !isChannel && !isDashboard && !isSystemSettings && !isLoginIllustration && !isUndesired && !isEmployees && !isRegion && !isUsersList && !isDeliveries && !isClearance && !isDoorRecycling && !isServiceStation && !isSortingCenter
      })
      const names = new Set(filtered.map(m => m.name))
      if (!names.has('清运量统计')) {
        filtered.push({
          id: 'asset-cleaning-stats',
          path: '/asset-cleaning-stats',
          name: '清运量统计',
          iconBaseName: 'qingyunliangtongji'
        })
      }
      if (!names.has('设备投递量统计')) {
        filtered.push({
          id: 'asset-device-delivery-stats',
          path: '/asset-device-delivery-stats',
          name: '设备投递量统计',
          iconBaseName: 'shebeitongji2'
        })
      }
      if (!names.has('清运员统计')) {
        filtered.push({
          id: 'cleaner-stats',
          path: '/cleaner-stats',
          name: '清运员统计',
          iconBaseName: 'qingyunyuantongji'
        })
      }
      if (!names.has('分组管理')) {
        filtered.push({
          id: 'cleaning-groups-menu',
          path: '/cleaning-groups',
          name: '分组管理',
          iconBaseName: 'fenzuguanli'
        })
      }
      if (!names.has('意见反馈')) {
        filtered.push({
          id: 'feedbacks-menu',
          path: '/feedbacks',
          name: '意见反馈',
          iconBaseName: 'yijianfankui'
        })
      }
      // 隐藏外部数据看板入口
      
      // 添加用户配置的应用（支持本地覆盖）
      let currentUserApps = []
      try {
        const raw = localStorage.getItem('user_apps_override') || '{}'
        const overrides = JSON.parse(raw)
        if (Object.prototype.hasOwnProperty.call(overrides, this.username)) {
          currentUserApps = Array.isArray(overrides[this.username]) ? overrides[this.username] : []
        } else {
          currentUserApps = userApps[this.username] || []
        }
      } catch (e) {
        currentUserApps = userApps[this.username] || []
      }
      currentUserApps.forEach(appName => {
        if (!names.has(appName) && appDetails[appName]) {
          const detail = appDetails[appName]
          filtered.push({
            id: 'app-' + detail.path,
            path: '/' + detail.path,
            name: appName,
            iconBaseName: detail.iconKey
          })
        }
      })
      
      const orderIndex = name => {
        const i = this.desiredOrder.indexOf(name)
        return i === -1 ? 999 : i
      }
      filtered.sort((a, b) => orderIndex(a.name) - orderIndex(b.name))
      
      // 统一更新图标
      filtered.forEach(m => {
          m.iconImg = this.getIconImgForMenu(m)
      })
      
      this.menuList = filtered
    }
  },
  mounted() {
    this.getActiveMenu()
    this.getUsername()
    this.loadAssetIcons()
    this.generateMenuList()
    window.addEventListener('user-apps-updated', this.generateMenuList)
  },
  beforeDestroy() { window.removeEventListener('user-apps-updated', this.generateMenuList) },
  // 监听路由变化，更新激活的菜单
  watch: {
    '$route': function() {
      this.getActiveMenu()
      this.generateMenuList()
    },
    // 监听路由权限变化，更新菜单
    routes: {
      handler() {
        this.generateMenuList()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.layout-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

/* 顶部导航栏 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  padding: 0 20px;
}

.header-left .logo {
  font-size: 20px;
  font-weight: bold;
  color: #303133;
}

.header-right .user-info {
  cursor: pointer;
}

/* 主体内容区 */
.main-container {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* 侧边栏 */
.sidebar {
  width: 200px;
  background-color: #ffffff;
  overflow-y: auto;
  border-right: 1px solid #e6e6e6;
}

/* 强制覆盖 Element UI 选中样式 */
::v-deep .el-menu-item.is-active {
  background-color: #28b652 !important;
  color: #fff !important;
}

.menu-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  vertical-align: middle;
  object-fit: contain;
}

/* 内容区 */
.content {
  flex: 1;
  background-color: #f5f7fa;
  overflow-y: auto;
}
</style>
